<script lang="ts" setup>
import { ref } from 'vue';
import ManifestExport from '@/components/HeaderButtons/ManifestExport.vue';
import TranslationExport from '@/components/HeaderButtons/TranslationExport.vue';

const showDropdown = ref(false);

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};
</script>

<template>
  <div class="relative bg-blue-400 text-white rounded-sm px-2 py-1" @mouseleave="() => showDropdown === true ? toggleDropdown() : null">
    <div class="text-sm cursor-pointer" @click="toggleDropdown">
      Export
    </div>

    <div v-if="showDropdown === true" class="right-0 absolute flex flex-col z-20 w-[150px] pt-1" @click="toggleDropdown">
      <ManifestExport />
      <TranslationExport />
    </div>
  </div>
</template>
